import { mockPlaceOrderApi, placeOrderApi } from './api/placeOrderApi'
import { PlaceOrderService } from './service/PlaceOrderService'
const api = import.meta.env.MODE === 'development' ? mockPlaceOrderApi : placeOrderApi
export const placeOrderService = new PlaceOrderService(api)
